var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"size":"sm","id":"company-profile-modal","title":"Company Profile","closeOnEsc":false,"closeOnOverlay":false,"close":false}},[_c('company-profile',{attrs:{"modal":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }